// Suffix-matched on the normalized pathname, mirroring the native clients.
export const matchesDeeplink = (
  url: string | undefined,
  deeplinkPath: string,
): boolean => {
  if (!url) return false;
  try {
    const { pathname } = new URL(url, 'https://placeholder.invalid');
    const withoutTrailingSlash = pathname.replace(/\/+$/, '');
    const normalized = (withoutTrailingSlash || '/').toLowerCase();
    return normalized.endsWith(deeplinkPath);
  } catch {
    return false;
  }
};
